
































  import Vue, { PropType } from 'vue';
  import Demande from '@/domain/models/demande';

  export default Vue.extend({
    name: 'EnteteGestionTraitement',
    props: {
      demande: {
        type: Object as PropType<Demande>,
        required: true,
      },
    },
  });
